import { FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Card } from '@mui/material'
import { boxShadow } from '@/constant'

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))

export const LabeledCheckbox = styled(FormControlLabel)(() => ({
  width: '76px',
  margin: 0,
}))

export const GrayCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'expand',
})<{ expand?: 'true' | 'false' }>(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
  paddingBottom: '8px',
  backgroundColor: '#F7F7F750',
  gap: '8px',
  overflow: 'hidden',
  // ...(expand === "true" && { gap: "8px" }),
}))

export const ScrollY = styled('div')(() => ({
  height: '100%',
  overflow: 'auto',
  ...(navigator?.userAgent?.indexOf('Chrome') != -1 && { overflow: 'overlay' }),
}))

export const ErrorMessage = styled('div')(() => ({
  color: '#d32f2f',
}))
